export default __webpack_public_path__ + "static/media/step2.2ec26499.mov";